<template>
  <div class="resign-history-container">
    <Govem_bar />

    <v-container fluid class="pa-4 pa-md-8">
      <!-- ── Header ─────────────────────────────────────────────── -->
      <div class="d-flex flex-wrap align-center justify-space-between mb-6">
        <div>
          <h2 class="font-weight-bold error--text mb-1">
            <v-icon large color="error" class="mr-2">mdi-account-off</v-icon>
            ประวัติพนักงานพ้นสภาพ
          </h2>
          <span class="grey--text text--darken-1 ml-2">
            บันทึกการลาออก / พ้นสภาพพนักงานราชการ
          </span>
        </div>
        <v-btn color="primary" outlined rounded @click="$router.back()">
          <v-icon left>mdi-arrow-left</v-icon> กลับ
        </v-btn>
      </div>

      <!-- ── Summary Cards ──────────────────────────────────────── -->
      <v-row class="mb-6">
        <!-- รวมทั้งหมด -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-xl stat-card-red" elevation="3">
            <v-card-text class="white--text pa-5">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-caption opacity-80">พ้นสภาพทั้งหมด</div>
                  <div class="display-stat font-weight-black mt-1">
                    {{ resignedList.length }}
                  </div>
                  <div class="text-caption mt-1">ราย</div>
                </div>
                <v-avatar color="white" size="52" class="glass-icon">
                  <v-icon color="error darken-2" size="28"
                    >mdi-account-off</v-icon
                  >
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- ลาออกเอง -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-xl stat-card-orange" elevation="3">
            <v-card-text class="white--text pa-5">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-caption opacity-80">ลาออกด้วยตนเอง</div>
                  <div class="display-stat font-weight-black mt-1">
                    {{ stats.voluntary }}
                  </div>
                  <div class="text-caption mt-1">ราย</div>
                </div>
                <v-avatar color="white" size="52" class="glass-icon">
                  <v-icon color="warning darken-2" size="28">mdi-logout</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- ครบสัญญา -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-xl stat-card-blue" elevation="3">
            <v-card-text class="white--text pa-5">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-caption opacity-80">ครบ / สิ้นสุดสัญญา</div>
                  <div class="display-stat font-weight-black mt-1">
                    {{ stats.contract_end }}
                  </div>
                  <div class="text-caption mt-1">ราย</div>
                </div>
                <v-avatar color="white" size="52" class="glass-icon">
                  <v-icon color="info darken-2" size="28"
                    >mdi-file-document-remove</v-icon
                  >
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- เหตุอื่น -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-xl stat-card-grey" elevation="3">
            <v-card-text class="white--text pa-5">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-caption opacity-80">เหตุอื่น ๆ</div>
                  <div class="display-stat font-weight-black mt-1">
                    {{ stats.other }}
                  </div>
                  <div class="text-caption mt-1">ราย</div>
                </div>
                <v-avatar color="white" size="52" class="glass-icon">
                  <v-icon color="grey darken-1" size="28"
                    >mdi-dots-horizontal-circle</v-icon
                  >
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- ── Data Table Card ────────────────────────────────────── -->
      <v-card class="rounded-xl" elevation="2">
        <!-- Toolbar: Search + Filter -->
        <v-toolbar
          flat
          color="white"
          class="px-4 pt-4 pb-2 rounded-t-xl"
          height="auto"
        >
          <v-row class="fill-height align-center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="searchQuery"
                placeholder="ค้นหา ชื่อ, เลขบัตร, ตำแหน่ง..."
                filled
                rounded
                dense
                hide-details
                prepend-inner-icon="mdi-magnify"
                @input="filterData"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="filterYear"
                :items="availableYears"
                label="กรองตามปีที่ลาออก (พ.ศ.)"
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-calendar-filter"
                @change="filterData"
              ></v-select>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                v-model="filterReasonType"
                :items="reasonTypeOptions"
                label="ประเภทการพ้นสภาพ"
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-filter-variant"
                @change="filterData"
              ></v-select>
            </v-col>

            <v-col cols="12" md="2" class="d-flex justify-end">
              <div
                class="grey--text text-body-2 mr-2 d-none d-md-flex align-center"
              >
                พบ
                <strong class="mx-1">{{ filteredList.length }}</strong> รายการ
              </div>
              <v-btn color="info" fab x-small dark @click="loadData">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>

        <!-- Data Table -->
        <v-data-table
          :headers="headers"
          :items="filteredList"
          :items-per-page="10"
          :loading="loading"
          class="custom-table"
          loading-text="กำลังโหลดข้อมูล..."
          no-data-text="ไม่พบข้อมูลพนักงานพ้นสภาพ"
        >
          <!-- ชื่อ-นามสกุล -->
          <template v-slot:item.frist_name="{ item }">
            <div class="d-flex align-center py-2">
              <v-avatar color="error lighten-5" size="38" class="mr-3">
                <span class="error--text font-weight-bold">
                  {{ item.frist_name ? item.frist_name.charAt(0) : "?" }}
                </span>
              </v-avatar>
              <div>
                <div
                  class="font-weight-bold"
                  style="max-width:180px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;"
                >
                  {{ item.title_s }}{{ item.frist_name }} {{ item.last_name }}
                </div>
                <div class="grey--text text-caption">
                  {{ item.id_card || "-" }}
                </div>
              </div>
            </div>
          </template>

          <!-- เลขที่ตำแหน่ง + ตำแหน่ง -->
          <template v-slot:item.name_postion="{ item }">
            <div>
              <div class="font-weight-medium">
                {{ item.name_postion || "-" }}
              </div>
              <div class="grey--text text-caption">
                <v-icon x-small class="mr-1">mdi-identifier</v-icon
                >{{ item.id_position }}
              </div>
            </div>
          </template>

          <!-- ประเภทการพ้นสภาพ -->
          <template v-slot:item.remark="{ item }">
            <v-chip
              :color="getReasonColor(item.remark).bg"
              :text-color="getReasonColor(item.remark).text"
              x-small
              label
              class="font-weight-bold"
            >
              <v-icon x-small left>{{
                getReasonColor(item.remark).icon
              }}</v-icon>
              {{ extractReasonType(item.remark) }}
            </v-chip>
          </template>

          <!-- วันที่ลาออก -->
          <template v-slot:item.resignation_date="{ item }">
            <div>
              <div class="font-weight-medium">
                {{ formatThaiDate(item.resignation_date) }}
              </div>
              <div
                class="grey--text text-caption"
                v-if="item.service_years !== null"
              >
                <v-icon x-small>mdi-briefcase-clock</v-icon>
                อายุงาน {{ item.service_years }} ปี
              </div>
            </div>
          </template>

          <!-- วันที่บันทึก -->
          <template v-slot:item.resignation_recorded_at="{ item }">
            <span class="grey--text text-caption">
              {{ formatThaiDateTime(item.resignation_recorded_at) }}
            </span>
          </template>

          <!-- จำนวนสัญญา -->
          <template v-slot:item.contract_count="{ item }">
            <v-chip
              small
              color="info lighten-5"
              text-color="info darken-2"
              label
            >
              {{ item.contract_count || 0 }} ครั้ง
            </v-chip>
          </template>

          <!-- Actions -->
          <template v-slot:item.actions="{ item }">
            <v-btn icon small color="primary" @click="viewDetail(item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>

          <!-- No Data -->
          <template v-slot:no-data>
            <div class="text-center py-10">
              <v-icon size="72" color="grey lighten-3"
                >mdi-account-search-outline</v-icon
              >
              <p class="grey--text mt-3">ไม่พบข้อมูลพนักงานพ้นสภาพ</p>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <!-- ── Detail Dialog ──────────────────────────────────────── -->
    <v-dialog v-model="showDetailDialog" max-width="620px" scrollable>
      <v-card class="rounded-xl overflow-hidden" v-if="selectedEmployee">
        <!-- Header Banner -->
        <div class="detail-banner pa-5 d-flex align-center white--text">
          <v-avatar color="white" size="68" class="mr-4 elevation-3">
            <span class="error--text font-weight-black text-h5">
              {{
                selectedEmployee.frist_name
                  ? selectedEmployee.frist_name.charAt(0)
                  : "?"
              }}
            </span>
          </v-avatar>
          <div>
            <div class="text-h6 font-weight-bold">
              {{ selectedEmployee.title_s }}{{ selectedEmployee.frist_name }}
              {{ selectedEmployee.last_name }}
            </div>
            <div class="text-body-2 mt-1 opacity-90">
              <v-icon small class="mr-1">mdi-briefcase-outline</v-icon>
              {{ selectedEmployee.name_postion }}
            </div>
            <div class="text-caption mt-1 opacity-80">
              <v-icon x-small class="mr-1">mdi-identifier</v-icon>
              เลขที่ตำแหน่ง: {{ selectedEmployee.id_position }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-chip
            color="white"
            :text-color="getReasonColor(selectedEmployee.remark).text"
            label
            small
            class="font-weight-bold"
          >
            {{ extractReasonType(selectedEmployee.remark) }}
          </v-chip>
        </div>

        <v-card-text class="pa-5" style="max-height: 65vh; overflow-y: auto;">
          <!-- ข้อมูลการลาออก -->
          <div class="section-title mb-3">
            <v-icon color="error" small class="mr-1"
              >mdi-calendar-remove</v-icon
            >
            ข้อมูลการลาออก
          </div>
          <v-row dense class="mb-4">
            <v-col cols="6">
              <div class="detail-label">วันที่มีผลลาออก</div>
              <div class="detail-value error--text font-weight-bold">
                {{ formatThaiDate(selectedEmployee.resignation_date) }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">วันที่บันทึก</div>
              <div class="detail-value">
                {{
                  formatThaiDateTime(selectedEmployee.resignation_recorded_at)
                }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">อายุงานรวม</div>
              <div class="detail-value">
                <v-chip
                  x-small
                  color="info lighten-5"
                  text-color="info darken-2"
                >
                  {{
                    selectedEmployee.service_years !== null
                      ? selectedEmployee.service_years + " ปี"
                      : "-"
                  }}
                </v-chip>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">จำนวนครั้งที่ทำสัญญา</div>
              <div class="detail-value">
                {{ selectedEmployee.contract_count || "0" }} ครั้ง
              </div>
            </v-col>
            <v-col cols="12">
              <div class="detail-label">เหตุผล / รายละเอียด</div>
              <div class="detail-value pa-3 grey lighten-5 rounded-lg mt-1">
                {{ extractRemark(selectedEmployee.remark) || "-" }}
              </div>
            </v-col>
          </v-row>

          <v-divider class="mb-4"></v-divider>

          <!-- ข้อมูลส่วนตัว -->
          <div class="section-title mb-3">
            <v-icon color="primary" small class="mr-1">mdi-account-box</v-icon>
            ข้อมูลส่วนตัว
          </div>
          <v-row dense class="mb-4">
            <v-col cols="6">
              <div class="detail-label">เลขบัตรประชาชน</div>
              <div class="detail-value font-mono">
                {{ selectedEmployee.id_card || "-" }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">เพศ</div>
              <div class="detail-value">{{ selectedEmployee.sex || "-" }}</div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">วันเกิด</div>
              <div class="detail-value">
                {{
                  formatThaiDateFromParts(
                    selectedEmployee.brith_year,
                    selectedEmployee.brith_month,
                    selectedEmployee.brith_day
                  )
                }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">สถานภาพ</div>
              <div class="detail-value">
                {{ selectedEmployee.marital_status || "-" }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">ภูมิลำเนา</div>
              <div class="detail-value">
                {{ selectedEmployee.province || "-" }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">ประเภทตำแหน่ง</div>
              <div class="detail-value">
                {{ selectedEmployee.type_position || "-" }}
              </div>
            </v-col>
          </v-row>

          <v-divider class="mb-4"></v-divider>

          <!-- การศึกษา + เงินเดือน -->
          <div class="section-title mb-3">
            <v-icon color="warning" small class="mr-1">mdi-school</v-icon>
            การศึกษา & เงินเดือน
          </div>
          <v-row dense class="mb-4">
            <v-col cols="6">
              <div class="detail-label">วุฒิการศึกษา</div>
              <div class="detail-value">
                {{ selectedEmployee.ed_abb }}
                {{
                  selectedEmployee.ed_name
                    ? "(" + selectedEmployee.ed_name + ")"
                    : ""
                }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">สถาบัน</div>
              <div class="detail-value">
                {{ selectedEmployee.edd_university || "-" }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">เงินเดือนแรกบรรจุ</div>
              <div class="detail-value">
                {{ formatCurrency(selectedEmployee.salary_start) }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">เงินเดือนล่าสุด</div>
              <div class="detail-value success--text font-weight-bold">
                {{ formatCurrency(selectedEmployee.salary_s) }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">วันแรกบรรจุ</div>
              <div class="detail-value">
                {{
                  formatThaiDateFromParts(
                    selectedEmployee.appoin_year,
                    selectedEmployee.appoin_month,
                    selectedEmployee.appoin_day
                  )
                }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="detail-label">เครื่องราชอิสริยาภรณ์</div>
              <div class="detail-value">
                {{ selectedEmployee.last_royal_decoration || "-" }}
              </div>
            </v-col>
          </v-row>

          <!-- ประวัติวินัย (แสดงเฉพาะถ้ามีข้อมูล) -->
          <template
            v-if="
              selectedEmployee.disciplinary_offense ||
                selectedEmployee.disciplinary_history
            "
          >
            <v-divider class="mb-4"></v-divider>
            <div class="section-title mb-3">
              <v-icon color="primary" small class="mr-1">mdi-gavel</v-icon>
              ประวัติวินัย
            </div>
            <v-row dense class="mb-4">
              <v-col cols="12" v-if="selectedEmployee.disciplinary_offense">
                <div class="detail-label">ความผิดทางวินัย</div>
                <div
                  class="detail-value pa-3 error lighten-5 rounded-lg mt-1 error--text text-body-2"
                >
                  {{ selectedEmployee.disciplinary_offense }}
                </div>
              </v-col>
              <v-col cols="12" v-if="selectedEmployee.disciplinary_history">
                <div class="detail-label">ประวัติทางวินัย</div>
                <div
                  class="detail-value pa-3 warning lighten-5 rounded-lg mt-1 text-body-2"
                >
                  {{ selectedEmployee.disciplinary_history }}
                </div>
              </v-col>
            </v-row>
          </template>

          <!-- ไฟล์แนบ -->
          <template v-if="resignFileFromRemark(selectedEmployee.remark)">
            <v-divider class="mb-4"></v-divider>
            <div class="section-title mb-3">
              <v-icon color="info" small class="mr-1">mdi-paperclip</v-icon>
              เอกสารแนบ
            </div>
            <v-btn
              outlined
              color="info"
              small
              rounded
              :href="
                '../HRemployee_resign/' +
                  resignFileFromRemark(selectedEmployee.remark)
              "
              target="_blank"
            >
              <v-icon left small>mdi-file-pdf-box</v-icon>
              ดาวน์โหลดหนังสือลาออก
            </v-btn>
          </template>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            rounded
            color="grey lighten-3"
            @click="showDetailDialog = false"
          >
            <v-icon left small>mdi-close</v-icon> ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
      right
      rounded="pill"
    >
      <v-icon small class="mr-2">{{
        snackbar.color === "success" ? "mdi-check-circle" : "mdi-alert-circle"
      }}</v-icon>
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import Govem_bar from "../../../components/iven/govem_bar.vue";

export default {
  name: "IvenResignHistoryPage",
  components: { Govem_bar },

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      resignedList: [],
      filteredList: [],
      searchQuery: "",
      filterYear: null,
      filterReasonType: null,
      showDetailDialog: false,
      selectedEmployee: null,
      user: [],

      stats: { voluntary: 0, contract_end: 0, other: 0 },

      snackbar: { show: false, message: "", color: "success" },

      reasonTypeOptions: [
        "ลาออกด้วยความสมัครใจ",
        "ครบกำหนดสัญญาจ้าง",
        "เกษียณอายุ",
        "ถูกเลิกจ้าง",
        "โอนย้าย",
        "ถูกไล่ออก / ปลดออก (วินัย)",
        "เสียชีวิต",
        "อื่น ๆ"
      ],

      headers: [
        { text: "ชื่อ-นามสกุล", value: "frist_name", align: "start" },
        { text: "ตำแหน่ง", value: "name_postion", align: "start" },
        {
          text: "ประเภทการพ้นสภาพ",
          value: "remark",
          align: "center",
          sortable: false
        },
        { text: "วันที่ลาออก", value: "resignation_date", align: "center" },
        {
          text: "วันที่บันทึก",
          value: "resignation_recorded_at",
          align: "center"
        },
        { text: "ครั้งที่สัญญา", value: "contract_count", align: "center" },
        {
          text: "รายละเอียด",
          value: "actions",
          align: "center",
          sortable: false
        }
      ]
    };
  },

  computed: {
    availableYears() {
      const years = [
        ...new Set(this.resignedList.map(e => e.resign_year_th).filter(Boolean))
      ].sort((a, b) => b - a);
      return years;
    }
  },

  async mounted() {
    await this.userQuery();
    await this.loadData();
  },

  methods: {
    async userQuery() {
      try {
        const session = JSON.parse(localStorage.getItem("user")) || {};
        const res = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_ID: session.user_ID
        });
        this.user = res.data;
      } catch {
        /* silent */
      }
    },

    async loadData() {
      this.loading = true;
      try {
        const res = await this.$http.post("government_employee_del.php", {
          ApiKey: this.ApiKey,
          college_code: this.user.user_code || ""
        });
        this.resignedList = Array.isArray(res.data) ? res.data : [];
        this.filteredList = [...this.resignedList];
        this.computeStats();
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error");
      } finally {
        this.loading = false;
      }
    },

    computeStats() {
      this.stats.voluntary = this.resignedList.filter(
        e => this.extractReasonType(e.remark) === "ลาออกด้วยความสมัครใจ"
      ).length;
      this.stats.contract_end = this.resignedList.filter(
        e => this.extractReasonType(e.remark) === "ครบกำหนดสัญญาจ้าง"
      ).length;
      this.stats.other = this.resignedList.filter(
        e =>
          !["ลาออกด้วยความสมัครใจ", "ครบกำหนดสัญญาจ้าง"].includes(
            this.extractReasonType(e.remark)
          )
      ).length;
    },

    filterData() {
      let list = [...this.resignedList];

      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        list = list.filter(
          e =>
            (e.frist_name && e.frist_name.toLowerCase().includes(q)) ||
            (e.last_name && e.last_name.toLowerCase().includes(q)) ||
            (e.id_card && String(e.id_card).includes(q)) ||
            (e.name_postion && e.name_postion.toLowerCase().includes(q)) ||
            (e.id_position && e.id_position.includes(q)) ||
            (e.remark && e.remark.toLowerCase().includes(q))
        );
      }

      if (this.filterYear) {
        list = list.filter(e => e.resign_year_th == this.filterYear);
      }

      if (this.filterReasonType) {
        list = list.filter(
          e => this.extractReasonType(e.remark) === this.filterReasonType
        );
      }

      this.filteredList = list;
    },

    viewDetail(item) {
      this.selectedEmployee = item;
      this.showDetailDialog = true;
    },

    // ── Helpers ──────────────────────────────────────────────────
    extractReasonType(remark) {
      if (!remark) return "ไม่ระบุ";
      const match = remark.match(/^\[(.+?)\]/);
      return match ? match[1] : "ไม่ระบุ";
    },

    extractRemark(remark) {
      if (!remark) return "";
      return remark
        .replace(/^\[.+?\]\s*/, "")
        .replace(/\s*\[ไฟล์แนบ:.*?\]$/, "")
        .trim();
    },

    resignFileFromRemark(remark) {
      if (!remark) return null;
      const match = remark.match(/\[ไฟล์แนบ:\s*(.+?)\]/);
      return match ? match[1].trim() : null;
    },

    getReasonColor(remark) {
      const type = this.extractReasonType(remark);
      const map = {
        ลาออกด้วยความสมัครใจ: {
          bg: "orange lighten-5",
          text: "orange darken-3",
          icon: "mdi-logout"
        },
        ครบกำหนดสัญญาจ้าง: {
          bg: "blue lighten-5",
          text: "blue darken-3",
          icon: "mdi-file-document-remove"
        },
        เกษียณอายุ: {
          bg: "teal lighten-5",
          text: "teal darken-3",
          icon: "mdi-account-clock"
        },
        ถูกเลิกจ้าง: {
          bg: "red lighten-5",
          text: "red darken-3",
          icon: "mdi-account-cancel"
        },
        โอนย้าย: {
          bg: "primary",
          text: "primary",
          icon: "mdi-account-arrow-right"
        },
        "ถูกไล่ออก / ปลดออก (วินัย)": {
          bg: "deep-orange lighten-5",
          text: "deep-orange darken-3",
          icon: "mdi-gavel"
        },
        เสียชีวิต: {
          bg: "grey lighten-3",
          text: "grey darken-3",
          icon: "mdi-heart-broken"
        },
        "อื่น ๆ": {
          bg: "grey lighten-3",
          text: "grey darken-2",
          icon: "mdi-dots-horizontal-circle"
        }
      };
      return (
        map[type] || {
          bg: "grey lighten-3",
          text: "grey darken-2",
          icon: "mdi-help-circle"
        }
      );
    },

    formatThaiDate(dateStr) {
      if (!dateStr) return "-";
      const months = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ];
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },

    formatThaiDateTime(dtStr) {
      if (!dtStr) return "-";
      const months = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ];
      const d = new Date(dtStr);
      if (isNaN(d)) return dtStr;
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()} ${hh}:${mm} น.`;
    },

    formatThaiDateFromParts(year, month, day) {
      if (!year || !month || !day) return "-";
      const months = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ];
      const mi = parseInt(month) - 1;
      if (mi < 0 || mi > 11) return "-";
      return `${parseInt(day)} ${months[mi]} ${parseInt(year)}`;
    },

    formatCurrency(value) {
      if (!value || value == 0) return "-";
      return (
        "฿" +
        parseFloat(value).toLocaleString("th-TH", { minimumFractionDigits: 2 })
      );
    },

    showSnackbar(message, color = "success") {
      this.snackbar = { show: true, message, color };
    }
  }
};
</script>

<style scoped>
.resign-history-container {
  background-color: #f5f5f5;
  min-height: 100vh;
  font-family: "Sarabun", sans-serif;
}

/* ── Stat Cards ── */
.stat-card-red {
  background: linear-gradient(135deg, #dc2626 0%, #f87171 100%);
}
.stat-card-orange {
  background: linear-gradient(135deg, #a86400 0%, #a86400 100%);
}
.stat-card-blue {
  background: linear-gradient(135deg, #455a64 0%, #90a4ae 100%);
}
.stat-card-grey {
  background: linear-gradient(135deg, #4b5563 0%, #9ca3af 100%);
}

.display-stat {
  font-size: 2rem;
  line-height: 1.1;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}

.glass-icon {
  background: rgba(255, 255, 255, 0.25) !important;
  backdrop-filter: blur(4px);
}

/* ── Table ── */
.custom-table >>> th {
  font-size: 0.85rem !important;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #6b7280 !important;
  background: #fff !important;
  border-bottom: 1px solid #f3f4f6 !important;
  white-space: nowrap;
}
.custom-table >>> td {
  font-size: 0.93rem !important;
  color: #374151;
  border-bottom: 1px solid #f3f4f6 !important;
  height: 68px !important;
}
.custom-table >>> tbody tr:hover {
  background: #fef2f2 !important;
}

/* ── Detail Dialog ── */
.detail-banner {
  background: var(--hv-hero);
  min-height: 110px;
}
.section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #374151;
  display: flex;
  align-items: center;
}
.detail-label {
  font-size: 0.78rem;
  color: #9ca3af;
  margin-bottom: 2px;
}
.detail-value {
  font-size: 0.92rem;
  color: #263238;
  font-weight: 500;
}
.font-mono {
  font-family: "Courier New", monospace;
}
</style>
